// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 744 ? "config-policy" : chunkId) + "" + {"309":"3a0cc24c888fb00aa4e0","744":"6325b4bc5714393400bf"}[chunkId] + ".js";
};